module.exports = __webpack_public_path__ + "static/img/renter_bg1.96d505a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rule/renter_bg1.jpg
// module id = RqdR
// module chunks = 1